// Generated by purs version 0.14.4
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var coerce = function (dictCoercible) {
    return Unsafe_Coerce.unsafeCoerce;
};
export {
    coerce
};
//# sourceMappingURL=index.js.map
